import { useHistory, useLocation } from 'react-router-dom'
import { APP_AUTH, setStore } from 'src/utils/auth'
import useUserSession from './useUserSession'
import { useTranslation } from 'react-i18next'

const useAuthRedirect = () => {
  const { authenticated } = useUserSession()
  const history = useHistory()
  const { i18n } = useTranslation()
  const { pathname } = useLocation()

  return ({ authUrl = APP_AUTH.URL_SIGNIN, redirectUrl, disableAuthRedirect = false } = {}) => {
    if (!authenticated) {
      const path = redirectUrl || pathname
      setStore(APP_AUTH.REDIRECT_AFTER_SIGNIN, path)
      history.push(`/${i18n.language}${authUrl}`)
    } else if (!disableAuthRedirect && redirectUrl) {
      history.push(`/${i18n.language}${redirectUrl}`)
    }
  }
}

export default useAuthRedirect
